// extracted by mini-css-extract-plugin
export var orderDetails = "_ub-2";
export var orderImage = "_ub-1";
export var orderMeta = "_ub-3";
export var orderSummary = "_ub-0";
export var rightArrow = "_ub-4";